import {
  ButtonGroup,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverProps,
  PopoverTrigger,
} from '@chakra-ui/react';
import React from 'react';

import { CmButton } from '@/components/uiParts';

type Props = {
  closeOnEsc?: boolean;
  closeOnBlur?: boolean;
  isOpen: boolean;
  title: string;
  handleOk?: () => void;
  onClose: () => void;
  button: React.ReactNode;
} & PopoverProps;

export const CmPopover: React.FC<Props> = ({
  children,
  closeOnEsc = true,
  closeOnBlur = true,
  placement,
  isOpen,
  title,
  button,
  handleOk,
  onClose,
  onOpen,
}) => {
  return (
    <Popover
      {...{
        closeOnEsc,
        closeOnBlur,
        isOpen,
        onClose,
        onOpen,
        placement,
      }}
    >
      <PopoverTrigger>{button}</PopoverTrigger>
      {/*
       // @ts-ignore TS2590 */}
      <PopoverContent>
        <PopoverCloseButton
          onClick={onClose}
          size="lg"
          mt="-3px"
          marginRight="-7px"
        />
        <PopoverHeader>{title}</PopoverHeader>
        <PopoverBody>{children}</PopoverBody>
        <PopoverFooter
          border="0"
          alignItems="center"
          justifyContent="space-between"
          pb={4}
        >
          {handleOk !== undefined && (
            <ButtonGroup size="sm" flexDirection="row-reverse" width="full">
              <CmButton ml="5" onClick={onClose} variant="outline">
                戻る
              </CmButton>
              <CmButton onClick={handleOk}>実行</CmButton>
            </ButtonGroup>
          )}
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  );
};
